interface CreateRoomModalHeaderProps {
  onClose: () => void;
}

/**
 * Header for the create room modal.
 */
export function CreateRoomModalHeader({ onClose }: CreateRoomModalHeaderProps) {
  return (
    <div className="flex items-center justify-between p-5 border-b border-border">
      <h2 className="text-lg font-semibold">Create New Room</h2>
      <button
        onClick={onClose}
        className="p-2 -m-2 text-gray-400 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
        aria-label="Close"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}
